import React from "react";
import { LightbulbIcon } from "./HelpCenterIcons";

const STEPS = [
  { num: 1, label: "Set up your profile", desc: "Complete your profile information" },
  { num: 2, label: "Create membership plans", desc: "Define plans for your gym" },
  { num: 3, label: "Add gym owners", desc: "Onboard gym partners" },
  { num: 4, label: "Track performance", desc: "Monitor analytics and reports" },
];

const HelpCenterGettingStarted = () => {
  return (
    <div className="v2-help-pg-card">
      <div className="v2-help-pg-card__header">
        <div className="v2-help-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <LightbulbIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-help-pg-card__title">Getting Started</h3>
          <p className="v2-help-pg-card__subtitle">
            Quick steps to get you up and running
          </p>
        </div>
      </div>

      <div className="v2-help-pg-steps">
        {STEPS.map((step) => (
          <div className="v2-help-pg-step" key={step.num}>
            <div className="v2-help-pg-step__num">{step.num}</div>
            <div className="v2-help-pg-step__text">
              <span className="v2-help-pg-step__label">{step.label}</span>
              <span className="v2-help-pg-step__desc">{step.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpCenterGettingStarted;
